var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"d-flex flex-column gap-4"},[_c('IncludedOrderStatesBox',{attrs:{"order-states":_vm.statistics.order_states}}),_vm._v(" "),_c('apexchart',{attrs:{"type":"bar","height":(_vm.statistics.data.length * 60 * 4) + 'px',"options":_vm.chartOptions,"series":_vm.series}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }